import { Check } from "lucide-react";

export const Section = ({ title, children, testid }) => (
  <div className="mb-8" data-testid={testid}>
    {title && <h3 className="font-bold text-base text-[#1A1A1A] mb-3">{title}</h3>}
    {children}
  </div>
);

export const ChipRow = ({ children }) => <div className="flex flex-wrap gap-2.5 items-center">{children}</div>;

export const Chip = ({ active, onClick, label, testid }) => (
  <button type="button" onClick={onClick} data-testid={testid}
    className={`px-4 h-10 rounded-full border text-sm font-semibold transition-colors ${active ? "bg-[#064E3B] border-[#064E3B] text-white" : "bg-white border-[#E5E5E0] text-[#1A1A1A] hover:border-[#064E3B]"}`}>
    {label}
  </button>
);

export const OrWord = ({ lang }) => <span className="text-xs text-slate-500 font-semibold" data-testid="or-word">{lang === "ar" ? "أو" : "or"}</span>;

export const TEXT_MAX = 26;

export const FormInput = ({ testid, className = "", ...p }) => (
  <input {...p} data-testid={testid}
    className={`w-full h-12 px-4 rounded-xl border border-[#E5E5E0] bg-white text-sm outline-none focus:border-[#064E3B] focus:ring-2 focus:ring-[#064E3B]/15 ${className}`} />
);

export function Anchor({ k, errKey, errMsg, onRef, children, L }) {
  const bad = errKey === k;
  return (
    <div ref={(r) => onRef(k, r)} className={bad ? "border-[1.5px] border-[#B91C1C] rounded-xl p-1.5 mb-2" : ""}>
      {children}
      {bad && <p className="text-xs font-semibold text-[#B91C1C] -mt-3 mb-3" data-testid={`field-error-${k}`}>{errMsg || L("هذا الحقل مطلوب — أكمل تعبئته", "This field is required — please complete it")}</p>}
    </div>
  );
}

export const CheckRow = ({ testid, active, onToggle, label, hint }) => (
  <button type="button" onClick={onToggle} data-testid={testid} className="flex items-start gap-2.5 mt-3 text-start w-full">
    <span className={`w-5 h-5 mt-0.5 rounded-md border-2 flex items-center justify-center shrink-0 ${active ? "bg-[#064E3B] border-[#064E3B]" : "border-slate-300 bg-white"}`}>
      {active && <Check className="w-3.5 h-3.5 text-white" />}
    </span>
    <span><span className="block text-sm font-semibold">{label}</span>{hint && <span className="block text-xs text-slate-500 mt-0.5">{hint}</span>}</span>
  </button>
);
